<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <router-link :to="`/${ $options.module }`" class="button button-back">
                    {{ $t('general.form.buttons.cancel') }}
                </router-link>
            </section>
            <section class="content-header-section">
                <button
                    type="button"
                    class="button button-gray"
                    @click="actionSave"
                >
                    {{ $t('general.form.buttons.save') }}
                </button>
                <button
                    type="button"
                    class="button button-blue"
                    @click="actionPublish"
                >
                    {{ $t('general.form.buttons.publish') }}
                </button>
            </section>
        </header>
        <div v-if="element" class="content-form">
            <input-i18n
                field="title"
                :label="$t(`pages.${ this.$options.module }.form.labels.title`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.title`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
                :maxlength="100"
            />
            <input-textarea
                field="description"
                :label="$t(`pages.${ this.$options.module }.form.labels.description`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.description`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
            />
            <input-image
                field="icon"
                :element="element"
                :errors="errors"
                :label="$t(`pages.${ this.$options.module }.form.labels.icon`)"
                spec_dimm="recommended width 60px"
                spec_format="jpg or png"
            />
            <input-image
                field="image"
                :element="element"
                :errors="errors"
                :label="$t(`pages.${ this.$options.module }.form.labels.image`)"
                spec_dimm="630 x 354px"
                spec_format="jpg or png"
            />
            <input-i18n
                field="url"
                :label="$t(`pages.${ this.$options.module }.form.labels.url`)"
                :placeholder="$t(`pages.${ this.$options.module }.form.placeholders.url`)"
                :locales="element.locales"
                :errors="errors"
                :currentLanguage="currentLanguage"
                @actionChangeLang="actionChangeLang"
            />
        </div>
        <pop-down
            v-if="pop.active"
            :class="pop.className"
            @close="popClose"
        >
            {{ pop.message }}
        </pop-down>
    </main>
</template>

<script>
import PopDownMixin from '@/components/PopDownMixin';
import FormMixin from '@/components/form/FormMixin';

export default {
    mixins: [FormMixin, PopDownMixin],
    name: 'PppElementsForm',
    module: 'pppelements',
    emptyElement: {
        state: 0,
        locales: {
            de: {
                title: '',
                url: '',
                description: '',
            },
            it: {
                title: '',
                url: '',
                description: '',
            },
            fr: {
                title: '',
                url: '',
                description: '',
            },
            en: {
                title: '',
                url: '',
                description: '',
            },
        },
    },
};
</script>
